import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import styles from './RadioButtons.css';

const PlainRadioInput = ({
    input,
    value,
    id,
    primaryColor,
    color,
    checked,
}) => (<React.Fragment>
    {input ? <input
        id={`${id}-${value}`}
        type="radio"
        {...input}
        checked={input.value === value}
        aria-checked={input.value === value}
        value={value}
        className={styles.input}
    /> : null}
    <div
        className={styles.circleCont}
        aria-hidden="true"
        style={{ borderColor: color || primaryColor }}
    >
        <div
            className={cx(styles.innerCircle, {
                [styles.checked]: input ? input.value === value : checked,
            })}
            style={{ backgroundColor: color || primaryColor }}
        />
    </div>
</React.Fragment>);

PlainRadioInput.propTypes = {
    input: PropTypes.object,
    color: PropTypes.string,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
        PropTypes.number,
    ]),
    id: PropTypes.string,
    primaryColor: PropTypes.string,
    // 'checked' prop must be passed, if not using 'input'
    checked: PropTypes.bool,
};

export default connect(
    ({ theme: { primaryColor } }) => ({ primaryColor }),
)(PlainRadioInput);



// WEBPACK FOOTER //
// ./src/client/Components/Forms/RadioButtons/PlainRadioInput.js